import { Component, OnInit } from '@angular/core';
import { TabName } from '../../../models/_enum-collections';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-rfp-award-letter',
  templateUrl: './rfp-award-letter.component.html',
  styleUrls: ['./rfp-award-letter.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class RfpAwardLetterComponent implements OnInit {
  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.RfpAwardLetter;
    this.prevDocumentType = PreviewDocumentTypes.rfpAward;
  }
}
